import { http } from '../../../../api/http';

export interface CuentaPorCobrarPagar {
  idMovimiento: number;
  tipoDocumento: string | null;
  serieDocumento: string | null;
  numeroDocumento: string | null;
  fechaEmision: string | null;
  fechaVencimiento: string | null;
  idPersona: number | null;
  nombreAuxiliar: string | null;
  numeroIdentificacion: string | null;
  importeTotal: number;
  pagosACuenta: number;
  saldo: number;
  monedaSimbolo: string | null;
  diasVencido: number;
  estado: string | null;
}

export interface CuentasFiltro {
  fechaInicio?: string;
  fechaFin?: string;
  idPersona?: number;
  idMoneda?: number;
  mostrarSaldados?: boolean;
}

const ENDPOINT = '/tesoreria/cuentas';

export class CuentasService {
  public static async getCuentasPorCobrar(filtro?: CuentasFiltro): Promise<CuentaPorCobrarPagar[]> {
    const params = new URLSearchParams();
    if (filtro?.fechaInicio) params.append('fechaInicio', filtro.fechaInicio);
    if (filtro?.fechaFin) params.append('fechaFin', filtro.fechaFin);
    if (filtro?.idPersona) params.append('idPersona', filtro.idPersona.toString());
    if (filtro?.idMoneda) params.append('idMoneda', filtro.idMoneda.toString());
    if (filtro?.mostrarSaldados) params.append('mostrarSaldados', 'true');
    params.append('tipo', 'COBRAR');
    const response = await http.get(`${ENDPOINT}/por-cobrar?${params.toString()}`);
    return response.data;
  }

  public static async getCuentasPorPagar(filtro?: CuentasFiltro): Promise<CuentaPorCobrarPagar[]> {
    const params = new URLSearchParams();
    if (filtro?.fechaInicio) params.append('fechaInicio', filtro.fechaInicio);
    if (filtro?.fechaFin) params.append('fechaFin', filtro.fechaFin);
    if (filtro?.idPersona) params.append('idPersona', filtro.idPersona.toString());
    if (filtro?.idMoneda) params.append('idMoneda', filtro.idMoneda.toString());
    if (filtro?.mostrarSaldados) params.append('mostrarSaldados', 'true');
    params.append('tipo', 'PAGAR');
    const response = await http.get(`${ENDPOINT}/por-pagar?${params.toString()}`);
    return response.data;
  }
}
